module.exports = __webpack_public_path__ + "img/b_Biofer_right.25805983.jpeg";